import React from "react";
import RequestInquiryModal from "./RequestInquiryModal";
import {styled} from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import FacilityEditModal from "./FacilityEditModal";
import InstallApplicationModal from "./installApplicationModal";
import {DialogContent, DialogTitle} from "@mui/material";
import OnlineRegistrationModal from "./onlineRegistrationModal";
import ViewListOfOfficesModal from "./viewListOfOfficesModal";
import ImageCropperModal from "./imageCropperModal";
import ReviewInquiryModal from "./reviewInquiryModal";

export const DialogStyled = styled(Dialog)(({minWidth, width, minHeight, height}) => ({
    '& .MuiDialog-paper': {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minWidth: minWidth ?? "440px",
        width: width ?? "440px",
        minHeight: minHeight ?? "200px",
        height: height ?? minHeight,
        paddingBottom: 12,
        overflow: "hidden !important",
        borderRadius: 12,
        boxShadow: "unset!important"
    },

}))

export const DialogTitleStyled = styled(DialogTitle)((theme) => ({
    height: 54,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
}))

export const DialogContentStyled = styled(DialogContent)((theme) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
}))

const ModalComponent = () => {
    return (
        <>
            <RequestInquiryModal/>
            <ReviewInquiryModal/>
            <FacilityEditModal/>
            <InstallApplicationModal/>
            <OnlineRegistrationModal/>
            <ViewListOfOfficesModal/>
            <ImageCropperModal/>
        </>
    )
};

export default ModalComponent;